<template>
    <DModal
        :show="showModal"
        :title="__(`contracts.pricings.mail_templates.${mailTemplate}`)"
        is-big
        overflow-auto
        @close="closeModal"
    >
        <div
            v-if="displayData"
            class="modal-base"
        >
            <DTabs>
                <DTabItem
                    :label="__('tools.emails.modal.tabs.html')"
                    :active="currentTab === 0"
                    @click="changeTab(0)"
                />
                <DTabItem
                    :label="__('tools.emails.modal.tabs.plain_text')"
                    :active="currentTab === 1"
                    @click="changeTab(1)"
                />
            </DTabs>

            <DCard
                v-if="currentTab === 0"
                class="ignore-parent-styles"
            >
                <!-- eslint-disable vue/no-v-html -->
                <div v-html="divFromHTMLBody()" />
                <!--eslint-enable-->
            </DCard>

            <DCard
                v-if="currentTab === 1"
                padding
            >
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="raw-textbox"
                    v-html="displayData.text"
                />
                <!--eslint-enable-->
            </DCard>
        </div>

        <div
            v-if="errors.length > 0"
            class="modal-error"
        >
            <DAlert
                v-for="(error, index) in errors"
                :key="index"
                color="danger"
            >
                {{ error }}
            </DAlert>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'EmailPreviewModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        displayData: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Array,
            default: () => { return [] }
        },
        mailTemplate: {
            type: String,
            default: 'default_pricing'
        }
    },
    emits: ['closeModal'],
    data () {
        return {
            currentTab: 0
        }
    },
    methods: {
        changeTab (tabIndex) {
            this.currentTab = tabIndex
        },
        closeModal () {
            this.$emit('closeModal')
        },
        divFromHTMLBody () {
            if (this.displayData === null) {
                return ''
            }

            return this.displayData.html.split('</head>')[1].split('</html>')[0]
                .replace('<body ', '<div ')
                .replace('</body>', '</div>')
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-header {
    display: flex;
    grid-gap: 15px;
    padding: 15px;
    align-items: center;
}
.modal-base {
    margin: 15px;
    margin-top: 0px;
    display: grid;
    grid-gap: 15px;

    & .raw-textbox {
        font-family: monospace, monospace;
        white-space: pre-wrap;
    }
}
.modal-error {
    margin: 15px;
    margin-top: 0px;
    display: grid;
    grid-gap: 15px;
}

.select-prompt {
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;

    & div {
        display: flex;
        flex-direction: column;
        grid-gap: 15px;
        align-items: center;

        & p {
            text-align: center;
            line-height: 1.5em;
            color: rgba(0,0,0,0.6);
        }
    }
}
</style>
